import { createApiClient } from '@/types/next-api.generated'
import { getCurrentEnvironment } from '@/utilities/getEnvironment'
import { encodePathParamsPlugin } from '@/platform/http/encodePathParamsPlugin'
import { applyPortalApiRequestHeaders } from '@/platform/http/requestInterceptors'

export { withNextApiHeaders } from '@/platform/http/requestInterceptors'

export function createNextApiClient(
  baseUrl: string,
  options?: Parameters<typeof createApiClient>[1],
) {
  const client = createApiClient(baseUrl, options)
  client.use(encodePathParamsPlugin)
  client.axios.interceptors.request.use(async (config) => {
    await applyPortalApiRequestHeaders(config)
    return config
  })
  return client
}

/**
 * Typed Zodios client for same-origin Next.js API routes under `/api/...`.
 * Reuses the same tracing/auth request headers as portalApiClient.
 *
 * Zodios rejects an empty base URL, so we use `/`. Axios joins that with
 * absolute paths like `/api/...` into the same-origin `/api/...` URL.
 */
export const nextApiClient = createNextApiClient('/', {
  validate: getCurrentEnvironment() === 'production' ? 'none' : 'request',
  axiosConfig: {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  },
})
